module.exports = __webpack_public_path__ + "img/down_arrow.c25dfac6.svg";